import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { en_US, zh_CN, NzI18nService } from 'ng-zorro-antd/i18n';
import { Title } from '@angular/platform-browser';
//import { NzModalService } from 'ng-zorro-antd/modal';
//import { UserManagementService } from './setting/user-management/user-management.service';
import { TranslateService } from '@ngx-translate/core';
//import { ConfigService } from './services/config.service';
import { ThemeService } from './services/theme.service';
import { LoadingService } from './services/loading.service';
//import { NzMessageService } from 'ng-zorro-antd/message';
import { LoginService } from 'src/app/services/login.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GlobalService } from 'src/app/services/global-service.service';
import { CustomerService } from 'src/app/services/customer.service';
import { environment } from 'src/environments/environment';

const privacyList = [
  {
    privacyId: 1,
    status: 0
  },
  {
    privacyId: 2,
    status: 0
  },
  {
    privacyId: 3,
    status: 0
  },
]

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = '博世智能出行售后';
  // theme setting
  visible = false;
  theme = 'light';
  language = 'zh';
  isReloginVisible = false;
  //isLoading: boolean=true;
  isSalesPortal: boolean = false;
  routerSub: Subscription | undefined;
  subscription: Subscription | undefined;
  isOfficialWebsite = true;
  isNewFeatureVisible = false;
  isStitchPromoVisible = false;
  /** 上一次记录的客户编码，用于识别真实切换（首次客户就绪不算切换） */
  private lastPromoCustomerCode: string | null = null;
  private customerSwitchSub: Subscription | undefined;
  /** 生产环境隐藏 chatbot */
  isProduction = environment.production;

  statusModalVisible: boolean = false;
  // My Consent : Data Privacy / User Terms
  myConsentModalVisible: boolean = false;
  isAgreeCrossBorderTransfer: boolean = false;
  isAgreeUserTerms: boolean = false;
  isAgreeDataPrivacy: boolean = false;
  privacyStatus: any[] = []

  get agreePrivacyStatus(): any {
    return this.loginService.getAgreeStatus;
  }
  constructor(
    private titleService: Title,
    private translate: TranslateService,
    private router: Router,
    private i18n: NzI18nService,
    private themeService: ThemeService,
    public loadingService: LoadingService,
    public loginService: LoginService,
    private globalService: GlobalService,
    private customerService: CustomerService

    ) {
      let currentPortalName = '';
      if (window.location.pathname.includes('Dealerportal')) {
        currentPortalName = 'Dealerportal'
      }
      if (window.location.pathname.includes('Salesportal')) {
        currentPortalName = 'Salesportal'
      }
      const sessionStoragePortal = localStorage.getItem('portalName');
      if (sessionStoragePortal) {
        if (currentPortalName !== "" && sessionStoragePortal !== currentPortalName) {
          this.isReloginVisible = true;
        }
      } else {
        localStorage.setItem("portalName", currentPortalName);
      }
      // set theme and language
      this.setConfig();
      // set app title
      this.titleService.setTitle(this.title);
  }

  ngOnInit(): void {
    this.subscription = this.globalService.globalVariable$.subscribe(value => {
      if (value) {
        if (window.location.pathname.includes('Salesportal')) {
          this.isOfficialWebsite = false;
        } else {
          if (value) {
            this.isOfficialWebsite = false;
          } else {
            this.isOfficialWebsite = true;
          }
        }
      } else {
        this.isOfficialWebsite = true;
      }
    });

    this.isSalesPortal = window.location.pathname.includes('sales-portal');
    this.getUserStatusList()

    // 订阅消息
    this.loginService.getAgreeStatus().subscribe(msg => {
      if(msg){
        this.getPrivacyList()
      }
    });
    // 订阅消息
    this.loginService.getUserPendingStatus().subscribe(msg => {
      if(msg){
        this.statusModalVisible = true
      }
    });
    // 切换客户后重新拉起促销弹窗：弹窗组件会按新客户重新请求活动内容，
    // 并按客户维度判断当天是否已展示
    this.customerSwitchSub = this.customerService.selectedCustomer$.subscribe(customer => {
      const customerCode = customer?.customerCode ?? null;
      if (!customerCode) {
        return;
      }
      if (this.lastPromoCustomerCode === null) {
        this.lastPromoCustomerCode = customerCode;
        return;
      }
      if (customerCode === this.lastPromoCustomerCode) {
        return;
      }
      this.lastPromoCustomerCode = customerCode;
      this.reopenPromotionPopup();
    });
  }

  /** 切换客户后重新拉起促销弹窗；登录态失效、状态拦截或新手引导中不拉起 */
  private reopenPromotionPopup(): void {
    if (!localStorage.getItem('token')) {
      return;
    }
    if (this.statusModalVisible) {
      return;
    }
    // 新手引导结束后由 handleNewFeatureGuideCompleted 拉起弹窗，避免两个弹窗同时出现
    if (this.isNewFeatureVisible) {
      return;
    }
    this.isStitchPromoVisible = true;
  }

  ngOnDestroy(): void {
    this.customerSwitchSub?.unsubscribe();
    localStorage.removeItem('token');
    localStorage.clear();
  }

  handleCancel(): void {
    this.isReloginVisible = false;
  }

  handleOk() {
    localStorage.setItem('isLogout', 'true');
    localStorage.clear();
    this.router.navigateByUrl('home/index');
    this.loadingService.showLoading();
    setTimeout(() => {
      location.reload();
      this.loadingService.hideLoading();
    }, 4000);
    this.isReloginVisible = false;
  }

  setConfig() {
    const config: any = localStorage.getItem('template_config') || '{}';
    const { language = 'zh', theme = 'light' } = JSON.parse(config);
    this.theme = theme;
    this.language = language;
    this.translate.use(this.language);
    this.i18n.setLocale(this.language === 'en'? en_US : zh_CN);
  }

  // get privacy agree list
  getUserStatusList(){
    this.loginService.userData$.subscribe((userData: any) => {
      if(userData){
        const loginStatus = userData?.queryUserPageInfoResDTO?.status
        if(loginStatus !== 2){
          this.statusModalVisible = true
          this.isNewFeatureVisible = false
          this.isStitchPromoVisible = false
          return
        } else {
          this.isNewFeatureVisible = true
          this.isStitchPromoVisible = false
        }
        this.getPrivacyList()
      }
    })
  }

  handleNewFeatureGuideCompleted(): void {
    this.isNewFeatureVisible = false;
    this.isStitchPromoVisible = true;
  }

  handleStitchPromoClosed(): void {
    this.isStitchPromoVisible = false;
  }

  closeLoginStatusModal(){
    this.statusModalVisible = false
    this.loginService.sendUserPendingStatus(false)
  }

  // get privacy agree list
  getPrivacyList(){
    this.loginService.userData$.subscribe((userData: any) => {
      if(userData?.queryUserPageInfoResDTO?.status !== 2) return
      this.loginService.getPrivacyList().subscribe(res => {
        if(res.code === 200){
          this.privacyStatus = privacyList.map(i=>{
            const data = res?.data?.find((v:any)=> v.privacyId === i.privacyId )
            return data ?  { ...i, ...data}: {...i }
          })
          if(!(this.privacyStatus?.length) || this.privacyStatus?.some(i=> i.status === 0)){
            this.myConsentModalVisible = true
          }
          this.isAgreeCrossBorderTransfer = this.privacyStatus.some(i=> i.privacyId === 1 && i.status === 1)
          this.isAgreeUserTerms = this.privacyStatus.some(i=> i.privacyId === 2 && i.status === 1)
          this.isAgreeDataPrivacy = this.privacyStatus.some(i=> i.privacyId === 3 && i.status === 1)
        }

      })
    })
  }

  closePrivacyModal(){
    this.myConsentModalVisible = false
    this.loginService.sendAgreeStatus(false)
  }

  // agree all privacy
  handleClickAgreeAll(){
    const params = this.privacyStatus.map(i=>{
      return {
        ...i,
        status: 1
      }
    })
    this.loginService.updatePrivacy(params).subscribe(res => {
      this.myConsentModalVisible = false
    })
  }
  // navigate to privacy page
  handleViewUserTerms($event: any){
    $event.stopPropagation();
    $event.preventDefault();
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/myAccount/user-terms`]);
  }
  handleViewDataPrivacy($event: any){
    $event.stopPropagation();
    $event.preventDefault();
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/myAccount/data-protection-policy`]);
  }
}
